export default __webpack_public_path__ + "static/media/mini.938f8b5f.jpg";